import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import { Markdown } from './Markdown';
import styled from 'styled-components';
import { overflow, truncate, textAlign, italic, bold, antialiased, letterSpacing, sansSerif, fontSize, lineClamp } from '../../helpers/typographyStyle.helper';
import { color } from '../../helpers/colorStyle.helper';
import { TextDisplayName, TextDefaultProps, TextPropsType } from './Text.types';
export var TextInlineSkin = styled.span.attrs({
  'data-id': function dataId(props) {
    return props['data-id'];
  }
}).withConfig({
  displayName: "Text__TextInlineSkin",
  componentId: "sc-1e69ph3-0"
})(["", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";"], overflow, truncate, textAlign, italic, bold, antialiased, letterSpacing, sansSerif, color, fontSize, lineClamp);
export var TextBlockSkin = TextInlineSkin.withComponent('div');
export var Text = function Text(props) {
  var markdown = props.markdown,
      markdownLinkMutator = props.markdownLinkMutator,
      children = props.children,
      inline = props.inline,
      restProps = __rest(props, ["markdown", "markdownLinkMutator", "children", "inline"]);

  var content = markdown && typeof children === 'string' ? React.createElement(Markdown, {
    markdown: markdown,
    size: restProps.size,
    linkMutator: markdownLinkMutator
  }, children) : children;

  if (inline) {
    return React.createElement(TextInlineSkin, restProps, content);
  } else {
    return React.createElement(TextBlockSkin, restProps, content);
  }
};
Text.propTypes = TextPropsType;
Text.displayName = TextDisplayName;
Text.defaultProps = TextDefaultProps;